import React from 'react';
import './AnnouncementModal.css';

function AnnouncementModal({ onClose }) {
  return (
    <div className="announcement-overlay" onClick={onClose}>
      <div className="announcement-modal" onClick={e => e.stopPropagation()}>
        <div className="announcement-icon">🎉</div>
        <h2>Extended Free Access!</h2>
        <p className="announcement-message">
          We're giving all users an <strong>extra 30 days free</strong> to enjoy BetPilot AI!
        </p>
        <p className="announcement-submessage">
          Your free trial has been extended. Continue exploring AI-powered picks, verified sellers, and more.
        </p>
        <button className="announcement-btn" onClick={onClose}>
          Got it, thanks! 🚀
        </button>
      </div>
    </div>
  );
}

export default AnnouncementModal;
